import { YStack } from 'tamagui';

import { H6Regular } from '../../components/text/Typography';
import { BookNextSessionWidget } from '../../components/tiles/BookNextSessionWidget';
import { UpcomingSessionWidget } from '../../components/tiles/UpcomingSessionWidget';

export const SessionWidgets = () => {
    // Today's date for the "today" example
    const todayDate = new Date();
    todayDate.setHours(10, 30, 0, 0);
    const todayEndDate = new Date(todayDate);
    todayEndDate.setHours(11, 30, 0, 0); // 1 hour session

    // Future date for the "upcoming" example (7 days from now)
    const futureDate = new Date();
    futureDate.setDate(futureDate.getDate() + 7);
    futureDate.setHours(11, 30, 0, 0);
    const futureEndDate = new Date(futureDate);
    futureEndDate.setHours(12, 30, 0, 0); // 1 hour session

    // Session that starts within 5 minutes (joinable)
    const joinableDate = new Date();
    joinableDate.setMinutes(joinableDate.getMinutes() + 3); // 3 minutes from now
    const joinableEndDate = new Date(joinableDate);
    joinableEndDate.setHours(joinableEndDate.getHours() + 1); // 1 hour session

    return (
        <>
            <YStack gap={16} maxWidth={400}>
                <H6Regular>Book Next Session Widget</H6Regular>
                <BookNextSessionWidget
                    title="Book your Money Map session"
                    description="You're ready to schedule your Money Map session with Raquel."
                    buttonLabel="Book your Money Map session"
                    guideImageUrl="https://cdn.prod.website-files.com/65b22d2d8aafb9c10048b930/67d87fa7e24881f9f55ffd64_20250317_Frutiful_Guide_Headshot_Raquel-p-500.png?w=100&h=100&fit=crop"
                    onPress={() => {
                        console.log('Booking session...');
                    }}
                />
            </YStack>
            <YStack gap={16} maxWidth={400}>
                <H6Regular>Upcoming Session (Joinable)</H6Regular>
                <UpcomingSessionWidget
                    title="Discovery"
                    session={{
                        startTime: joinableDate.toISOString(),
                        endTime: joinableEndDate.toISOString(),
                        videoConferenceUrl: 'https://meet.fruitful.com/demo',
                        attendeeTimezone: 'America/New_York',
                    }}
                    guide={{ firstName: 'Raquel' }}
                    onCardPress={() => {
                        console.log('Card pressed...');
                    }}
                />
            </YStack>

            <YStack gap={16} maxWidth={400}>
                <H6Regular>Upcoming Session (Not Joinable Yet)</H6Regular>
                <UpcomingSessionWidget
                    title="Money Map"
                    session={{
                        startTime: todayDate.toISOString(),
                        endTime: todayEndDate.toISOString(),
                        videoConferenceUrl: 'https://meet.fruitful.com/demo',
                        attendeeTimezone: 'America/New_York',
                    }}
                    guide={{ firstName: 'Raquel' }}
                    onCardPress={() => {
                        console.log('Card pressed...');
                    }}
                />
            </YStack>

            <YStack gap={16} maxWidth={400}>
                <H6Regular>Upcoming Session (Future)</H6Regular>
                <UpcomingSessionWidget
                    title="Optimization"
                    session={{
                        startTime: futureDate.toISOString(),
                        endTime: futureEndDate.toISOString(),
                        videoConferenceUrl: 'https://meet.fruitful.com/demo',
                        attendeeTimezone: 'America/New_York',
                    }}
                    guide={{ firstName: 'Raquel' }}
                    onCardPress={() => {
                        console.log('Card pressed...');
                    }}
                />
            </YStack>

            <YStack gap={16} maxWidth={400}>
                <H6Regular>{`"Row" variant`}</H6Regular>
                <UpcomingSessionWidget
                    title="Optimization"
                    session={{
                        startTime: futureDate.toISOString(),
                        endTime: futureEndDate.toISOString(),
                        videoConferenceUrl: 'https://meet.fruitful.com/demo',
                        attendeeTimezone: 'America/New_York',
                    }}
                    guide={{ firstName: 'Raquel' }}
                    onCardPress={() => {
                        console.log('Card pressed...');
                    }}
                    variant="row"
                />
            </YStack>
        </>
    );
};
